import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";

let ColorChanger = ({ setColorSel, colorSel }) => {
  let handleColor = function (e) {
    console.log(colorSel);
    setColorSel(e.target.value);
    console.log(colorSel);
  };

  return (
    <div className="color-select-area">
      <form>
        <input
          checked={colorSel === "5bc3fa"}
          name="color"
          type="radio"
          value="5bc3fa"
          id="5bc3fa"
          onChange={handleColor}
        />
        <label
          style={{ backgroundColor: `#5bc3fa` }}
          className="label-colors"
          htmlFor="5bc3fa"
        ></label>
        <input
          checked={colorSel === "de0c7b"}
          name="color"
          type="radio"
          value="de0c7b"
          id="de0c7b"
          onChange={handleColor}
        />
        <label
          style={{ backgroundColor: `#de0c7b` }}
          className="label-colors"
          htmlFor="de0c7b"
        ></label>
        <input
          checked={colorSel === "9cf0b3"}
          name="color"
          type="radio"
          value="9cf0b3"
          id="9cf0b3"
          onChange={handleColor}
        />
        <label
          style={{ backgroundColor: `#9cf0b3` }}
          className="label-colors"
          htmlFor="9cf0b3"
        ></label>
        <input
          checked={colorSel === "ffd5ae"}
          name="color"
          type="radio"
          value="ffd5ae"
          id="ffd5ae"
          onChange={handleColor}
        />
        <label
          style={{ backgroundColor: `#ffd5ae` }}
          className="label-colors"
          htmlFor="ffd5ae"
        ></label>
      </form>
    </div>
  );
};

let Hello = function (params) {
  let [colorSel, setColorSel] = useState("00000");
  let [isHidden, setIsHidden] = useState(false);
  let valQuote = useRef(null);
  let handleHidden = function (params) {
    setIsHidden(!isHidden);
    console.log(isHidden);
  };

  let [quote, setQuote] = useState("Hello world");

  let SettingQuote = (e) => {
    e.preventDefault();
    if (quote == valQuote.current.value) return;

    setIsHidden(true);

    console.log(valQuote.current.value);
    console.log(quote, isHidden);
    setQuote(valQuote.current.value);
  };

  useEffect(() => {
    setQuote(quote);
    setIsHidden(false);
  }, [quote]);

  return (
    <div className="hello-area">
      {isHidden ? (
        ""
      ) : (
        <motion.span
          style={{ color: `#${colorSel}` }}
          initial={{ opacity: 0, scale: 0.2, y: -92 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="hello-text"
        >
          {quote}
        </motion.span>
      )}
      <div className="hello-box">
        <button onClick={handleHidden}>Click me now</button>
        <form onSubmit={SettingQuote}>
          <input type="text" ref={valQuote}></input>
        </form>
      </div>
      <ColorChanger setColorSel={setColorSel} colorSel={colorSel} />
    </div>
  );
};

export default Hello;
